module.exports = __webpack_public_path__ + "static/media/mapa-a8.c29034c0.png";